export default __webpack_public_path__ + "static/media/shadow-type-4.a6eba350.svg";